<template>
  <div v-if="searchBool">
    <el-card class="box-card">
      <div class="for__box">
        <div class="flex__center">
          <div v-for="(item, index) in searchData" :key="index">
            <div v-if="item.type === 'input'" class="item__box">
              <span class="label__box">{{item.label}}</span>
              <el-input v-model.trim="form[item.key]" :placeholder="item.placeholder" class="ipt__box"></el-input>
            </div>
            <div v-if="item.type === 'select'" class="item__box">
              <span class="label__box">{{item.label}}</span>
              <el-select v-model="form[item.key]" @change="$forceUpdate()" class="ipt__box">
                <!-- <el-option value='' disabled selected style='display:none;'>{{ item.placeholder }}</el-option>  -->
                <el-option
                  v-for="(items, index) in item.options"
                  :label="items.label"
                  :value="items.val"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!-- 时间选择 -->
            <div v-if="item.type === 'datetime'" class="item__box">
              <dateTime :label="item.label" :dateType="item.type" :keys="item.keys" :values="[form[item.keys[0]], form[item.keys[1]]]" @onChange="datetimeChange" />
            </div>
            <div v-if="item.type === 'datetimerange'" class="item__box">
              <dateTime :label="item.label" :dateType="item.type" :keys="item.keys" :values="[form[item.keys[0]], form[item.keys[1]]]" @onChange="datetimeChange" />
            </div>
          </div>
        </div>
        <div class="btn__box">
          <el-button @click="resetFun">重置</el-button>
          <el-button type="primary" @click.enter.prevent="searchFun">搜索</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>

import dateTime from './items/date'

export default {
  name: 'search',
  props: {
    searchData: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      searchBool: false,
      form: {},
      datetimeValue: [],
    }
  },
  components: {
    dateTime
  },
  created() {
    // document.onkeydown = e => {
    //   const key = window.event.keyCode
    //   if (key == 13) {
    //     this.searchFun()
    //   }
    // }
  },
  mounted () {
    this.$nextTick(async () => {
      // 值回显
      await this.initValue()
      this.searchBool = true
      this.searchFun()
    })
  },
  methods: {
    changePage(e) {
      this.$emit('changePage', e)
    },
    searchFun() {
      const _form = JSON.parse(JSON.stringify(this.form))
      let _keys = Object.keys(_form)
      // 为空就不传字段了（后台id全匹配）
      let search_form = {}
      _keys.map(item => {
        if (_form[item]) {
          search_form[item] = _form[item]
        }
      })
      // this.$emit('search', search_form)
      this.$emit('search', _form)
    },
    getSearchInfo() {
      return this.form
    },
    resetFun() {
      this.form = {}
      this.$emit('search', this.form)
    },
    // 多个时间选择
    datetimeChange (value) {
      let keys = Object.keys(value)
      if (keys) {
        keys.forEach((item, index) => {
          this.form[item] = value[item]
        })
      }
    },
    // 回显值
    initValue () {
      return new Promise((resolve, reject) => {
        this.searchData.forEach((item, index) => {
          // console.log('initValue', item, item.type, item.value)
          if (item.value) {
            if (item.type === "datetime") {
              this.form[item.keys[0]] = item.value[0]
              this.form[item.keys[1]] = item.value[1]
            } else {
              this.form[item.key] = item.value
            }
          }
        })
        resolve()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.box-card {
  border: none !important;
  padding: 0 20px !important;
}
.pagination__box {
  margin-top: 50px;
  text-align: center;
}
.ipt__box {
  width: 210px;
}
.for__box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.label__box {
  display: inline-block;
  font-size: 14px;
  width: 80px;
}
.item__box {
  margin-right: 15px;
  margin-bottom: 10px;
}
.btn__box {
  margin-left: 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/search/index.vue